module.exports = __webpack_public_path__ + "static/img/wxapp_member_sport.21195c35.jpg";